import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Home from '../views/home/Home'
import Login from '../views/auth/Login'
import ChangePassword from "../views/auth/ChangePassword";
import ActivateAccount from "../views/auth/ActivateAccount";


import UserIndex from "../views/user/UserIndex"
import UserShow from "../views/user/UserShow"
import UserEdit from "../views/user/UserEdit"

import QuestionnaireIndex from "../views/questionnaire/QuestionnaireIndex"


Vue.use(VueRouter)
const routes = [
  {
    path: '/login/:username?/:password?',
    name: 'Login',
    component: Login,
    meta: {guest: true}
  },
  {
    path: '/',
    name: 'Home',
    component: QuestionnaireIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },

  {
    path: '/changePassword/:token?/:language?',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      guest: true
    }
  },

  {
    path: '/activateAccount/:token?/:language?',
    name: 'ActivateAccount',
    component: ActivateAccount,
    meta: {
      guest: true
    }
  },

  {
    path: '/user/show/:userId',
    name: 'UserShow',
    component: UserShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/edit/:userId',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/questionnaire/index',
    name: 'QuestionnaireIndex',
    component: QuestionnaireIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },

]

const router = new VueRouter({
  routes
})
//Trying to push for prod

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // Gestion pages réservées à l'admin
    if (to.meta.adminOnly) {
      if (store.getters.isAuthenticated && store.getters.isAdmin) {
        next()
        return
      } else {
        next('/login')
        return
      }
    }

    // Gestion pages réservées aux utilisateurs connectés
    if (store.getters.isAuthenticated) {
      next()
      return
    }

    next('/login')

  } else {
    next()
  }
})

// The meta: {guest: true} stops users that are logged in from accessing the routes with the guest meta.
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js